import React from "react"
import { assembleSrc } from "./icon"
import { iconsList as icons } from "./icons-list"

export function IconPreview({ properties }) {
  const { icon } = properties

  const label = getLabelForIcon(icon)

  return (
    <div className="flex items-center">
      <img
        src={assembleSrc(icon, "#000000", "#ffffff", "icon-only")}
        className="w-6 h-6 mr-4"
        alt={label}
      />
      {label}
    </div>
  )
}

function getLabelForIcon(name) {
  const target = icons.find(icon => icon.name === name)

  if (!target) {
    return "Icon"
  } else {
    return target.label
  }
}
